<template>
  <base-nav
    container-classes="container-fluid"
    class="navbar-top border-bottom navbar-expand pt-0 pb-0"
    :class="{ 'bg-success navbar-dark': type === 'default' }"
  >
    
    <i class="fa fa-globe" v-if="false"></i>
    <el-link @click="onClickLanguage" v-if="false" class="ml-1">{{currentLanguage}}</el-link>

    <!-- <h5>{{description}}</h5> -->
    <!-- Navbar links -->
    <ul class="navbar-nav align-items-center ml-md-auto">
      <li class="nav-item d-xl-none" v-if="appType=='mcz'">
        <!-- Sidenav toggler -->
        <div
          v-if="false"
          class="pr-3 sidenav-toggler"
          :class="{
            active: $sidebar.showSidebar,
            'sidenav-toggler-dark': type === 'default',
            'sidenav-toggler-light': type === 'light',
          }"
          @click="toggleSidebar"
        >
          <div class="sidenav-toggler-inner">
            <i class="sidenav-toggler-line"></i>
            <i class="sidenav-toggler-line"></i>
            <i class="sidenav-toggler-line"></i>
          </div>
        </div>
      </li>
      <el-tooltip class="item" effect="primary" content="マニュアル" placement="bottom">
        <el-button class="text-primary bg-transparent" @click="onClickManual"><i class="fas fa-book-open"></i></el-button>
      </el-tooltip>
      <!-- メッセージへのショートカット -->
      <base-dropdown
        menu-classes="dropdown-menu-lg bg-secondary dropdown-menu-right"
        class="nav-item "
        tag="li"
        title-tag="a"
        title-classes="nav-link"
        icon="ni ni-bell-55 text-primary"
        v-if="appType=='mcz'"
        @click="onClickNoticeMenu"
      >
        <div class="d-flex flex-column p-2">
          <div class="d-flex font-size-middle align-items-center font-weight-bold" style="border-bottom:1px dotted silver;padding-bottom:5px;">
            <i class="ni ni-bell-55"></i>
            <div class="ml-2">メッセージ</div>
          </div>
          <div v-if="viewModel" class="mt-2 ml-2 mb-3 font-size-small">
            <div v-for="notice in viewModel.noticeList" class="mb-2 font-size-small" :key="notice.sk" >
              <div class="font-size-xsmall">{{dateStringFormatMD(notice.createdAt)}}</div>
              <a href="#!" class="font-weight-bold" @click.prevent="onClickNotice(notice.sk)">{{notice.notice.title}}</a><br />
              <a href="#!" @click.prevent="onClickNotice(notice.notice.type, notice.notice.linkedId)">{{notice.notice.content}}</a>
            </div>
            <div v-if="viewModel.noticeList.length == 0" class="mb-2 font-size-small">メッセージはありません</div>
          </div>

        </div>
      </base-dropdown>
    </ul>
    <ul class="navbar-nav align-items-center ml-auto ml-md-0">
      <base-dropdown
        menu-on-right
        class="nav-item global-user-dropdown"
        tag="li"
        title-tag="a"
        title-classes="nav-link pr-0"
      >
        <template v-slot:title-container>
          <a href="#" class="nav-link pr-0" @click.prevent>
            <div class="media align-items-center">
              <span class="avatar avatar-sm rounded-circle far fa-user">
                <!-- <img alt="Image placeholder" src="img/theme/team-4.jpg" /> -->
              </span>
              <div class="media-body ml-2 d-none d-lg-block">
                <span class="mb-0 text-sm font-weight-bold">{{userData.name}}</span>
              </div>
            </div>
          </a>
        </template>

        <a class="dropdown-item" @click="showUser">
          <i class="fa fa-user"></i>ユーザー情報</a>
        <a class="dropdown-item" @click="signOut">
          <i class="fa fa-door-open"></i>ログアウト</a>
      </base-dropdown>
    </ul>
  </base-nav>
  
  <modal v-model:show="languageModal">
    <div style="position:absolute;right:0;top:0;">
      <el-button size="medium" circle @click="languageModal=false">
        <!-- <i class="fas fa-file-export"></i> -->
        <i class="fas fa-times"></i>
      </el-button>
    </div>
    
    <h3>{{$t('共通.11')}}</h3>
      <el-select
      placeholder=""
      @change="changeLanguage"
      size="small"
      v-model="language" >
      <el-option v-for="item in languageList"
                class="select-primary"
                :value="item.value"
                :label="item.name"
                :key="item.name">
      </el-option>
    </el-select>
  </modal>
</template>
<style scoped>
  .el-button {
    border-style: none;
  }
</style>
<script>
import Session from "@/appSession/Session"
import BaseNav from "@/components/Navbar/BaseNav";
import { Auth } from "aws-amplify";
import UserModel from "../../appModel/users/UserModel"
import UserInfo from "../../appUtils/UserInfo";
import DashboardNavbarViewModel from "@/appViews/Layout/ViewModel/DashboardNavbarViewModel"
import DateUtil from '@/appUtils/DateUtil';

export default {
  components: {
    BaseNav,
  },
  props: {
    appType: "",
    type: {
      type: String,
      default: "default", // default|light
      description:
        "Look of the dashboard navbar. Default (Green) or light (gray)",
    },
  },
  computed: {
    currentLanguage() {
      
      let current = ""
      
      const selected = this.languageList.filter(function(item) {
        
        return this.language == item.value
      }.bind(this))
      
      if (selected.length > 0) {
        current = selected[0].name
      }
      return current
    },
    routeName() {
      const { name } = this.$route;
      return this.capitalizeFirstLetter(name);
    },
    title() {
      const metaTitle = this.$route.meta.title
      console.log(`meta title:${metaTitle}`)

      const navInfo = this.$store.state.navInfo
      console.log(`navInfo.title:${navInfo.title}`)

      if (metaTitle == navInfo.title) {
        return !metaTitle ? "" : metaTitle
      } else {
        if (metaTitle && navInfo.title) {
          return `${metaTitle} - ${navInfo.title}`
        } else if (!metaTitle) {
          return !navInfo.title ? "" : navInfo.title
        } else if (!navInfo.title) {
          return !metaTitle ? "" : metaTitle
        } else {
          return ""
        }
      }
      
    },
    description() {
      const navInfo = this.$store.state.navInfo
      return !navInfo.description ? "" : navInfo.description
    }
  },
  mounted(){
    this.initNavbarData().then(() => {
      console.log('initNavbarData')
    })
  },
  data() {
    return {
      userData: {},
      userInfo: {},
      tenantId: "",
      language: "ja",
      languageList: [{value: "ja", name: "日本語"}, {value: "en", name: "English"}],
      activeNotifications: false,
      showMenu: false,
      searchModalVisible: false,
      searchQuery: "",
      languageModal: false,
      viewModel: null,
    };
  },
  methods: {
    onClickTodo() {
      // this.$refs.todolist.init()
      // let todoStore = this.$store.state.todo
      // todoStore.drawer = !todoStore.drawer
      // this.$store.commit('setTodo', todoStore)
      this.$emit('showtodolist', {})

    },
    
    async onClickNoticeMenu() {
      // ViewModel初期化
      this.viewModel = await DashboardNavbarViewModel.init(this.userInfo.group, this.userInfo.sub)
      // 自身宛の直近の通知を取得
      await this.viewModel.getNoticeList()
      
    },
    /**
     * メッセージのリンククリック時
     */
    async onClickNotice(type, linkedId) {
      if (type == "2"){ // 検査個所の場合
        let noticeStore = this.$store.state.notice
        noticeStore.linkedId = linkedId
        this.$store.commit("setNotice", noticeStore)
        let projectId = linkedId.split("#")[1]

        this.$router.push({
          path: `/projectMain`,
          query: { id: `${projectId}` },
        });
      }
    },
    
    async initNavbarData() {
      // let result = await Auth.currentUserInfo()
      // alert(JSON.stringify(result,null,"\t"))
      try {
        // セッション情報取得
        // this.session = await Session.init(this.$store.state.session.id)
        // console.log(`session: ${JSON.stringify(this.session.info)}`)
        // this.tenantId = this.session.info.tenant.id
        
        // ログインユーザ情報
        // this.userInfo = await UserInfo.getUserInfo()
        this.userInfo = await this.$root.getUserInfo()
        this.tenantId = this.userInfo.group
        // // ViewModel初期化
        // this.viewModel = await DashboardNavbarViewModel.init(this.tenantId, this.userInfo.sub)
       
        const userId = this.userInfo.userName
        console.log(`initNavbarData ${userId}`)
        const pk = this.userInfo.group
        const sk = UserModel.createSk(this.userInfo.sub)
        //alert(`pk:${pk}, sk:${sk}`)
        const userData = await UserModel.getUser({pk: pk, sk: sk}, this.tenantId)
        //alert(JSON.stringify(userData,null,"\t"))
        this.userData = userData.user
      } catch (e) {
        console.log(`ユーザ情報取得エラー`)
      }
    },
    capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    toggleNotificationDropDown() {
      this.activeNotifications = !this.activeNotifications;
    },
    closeDropDown() {
      this.activeNotifications = false;
    },
    toggleSidebar() {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
    },
    hideSidebar() {
      this.$sidebar.displaySidebar(false);
    },
    signOut: function() {
      // ログイン状態のフラグを更新
      this.$store.commit("setLoginFlg", false)
      
      this.$router.push({
        name: 'Signin'
      })
      Auth.signOut()
    },
    async showUser() {
      
      const currentPath = this.$router.currentRoute._rawValue.path

      // let userinfo = await UserInfo.getUserInfo()
      let userinfo = await this.$root.getUserInfo()
      const userId = userinfo.sub
      let params = this.$store.state.editUserParams
      params.editUserId = userId
      params.createFlg = false
      params.fromNavbar = true

      this.$store.commit("setEditUserParams", params)

      this.$router.push({
        path: `/editusermodal`,
      });

    },
   
    onClickLanguage() {
      this.languageModal = true
    },
    changeLanguage(value) {
      this.$i18n.locale = value;    
    },
    /**
     * n日後を表示
     */
    dayLater(dateString) {
      let day = DateUtil.dayOfDiff(dateString)
      if (day == 0) {
        return "本日"
      } else {
        return `${day}日後`
      }
    },
    /**
     * 日付文字を別の形式に変更
     */
    dateStringFormatMD(dateString) {
      if (dateString) {
        return DateUtil.getFormatString(dateString, "YYYY年MM月DD日 HH:mm")
      } else {
        return "-"
      }
    },
    dateStringFormatTime(dateString){
      if (dateString) {
        return DateUtil.getFormatString(dateString, "HH:mm")
      } else {
        return "-"
      }
    },
    onClickManual(){
      window.open(`./manual/index.html`, '_blank')
    }
  },
};
</script>
